import React from "react";

const icons = {
  x: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.02398 3.7757C4.25829 3.54139 4.63819 3.54139 4.87251 3.7757L14.2556 13.1588C14.4899 13.3931 14.4899 13.773 14.2556 14.0073C14.0212 14.2416 13.6413 14.2416 13.407 14.0073L4.02398 4.62423C3.78966 4.38992 3.78966 4.01002 4.02398 3.7757Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.74458 14.0073C3.51026 13.773 3.51026 13.3931 3.74458 13.1587L13.1276 3.77569C13.3619 3.54138 13.7418 3.54138 13.9762 3.77569C14.2105 4.01001 14.2105 4.38991 13.9762 4.62422L4.5931 14.0073C4.35879 14.2416 3.97889 14.2416 3.74458 14.0073Z"
        fill="currentColor"
      />
    </svg>
  ),
  selectDownArrow: (
    <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.25586 1.8689L7.25587 7.86891"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M7.25586 7.8689L13.2559 1.86894"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
  checkmark: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="8" fill="#FF6491" />
      <path
        d="M11.5446 4.25L11.0642 4.72507C9.40913 6.38373 8.15602 7.75977 6.59854 9.34384L4.88827 7.89752L4.37094 7.45938L3.5 8.49403L4.01199 8.92683L6.20788 10.7849L6.68294 11.1861L7.12631 10.748C8.94204 8.9283 10.237 7.4723 12.0249 5.68058L12.5 5.2002L11.5445 4.25007L11.5446 4.25Z"
        fill="#2C272D"
      />
    </svg>
  ),
  remove: (
    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.45474 2.81791H5.87517V1.4571C5.87517 1.1373 6.13498 0.875 6.45468 0.875H10.5456C10.8653 0.875 11.1251 1.13732 11.1251 1.4571V2.81775L15.5455 2.8179C15.5455 2.8179 15.5455 2.8179 15.5455 2.8179C15.8652 2.81791 16.125 3.08023 16.125 3.40001C16.125 3.71981 15.8652 3.98211 15.5455 3.98211H14.1705V16.5429C14.1705 16.8627 13.9107 17.125 13.591 17.125H3.4092C3.08948 17.125 2.82969 16.8627 2.82969 16.5429L2.82954 3.98211H1.4545C1.13479 3.98211 0.875 3.71979 0.875 3.40001C0.875 3.08012 1.13513 2.81791 1.45474 2.81791ZM9.96606 2.03921H7.03434V2.70342L9.96606 2.70357V2.03921ZM3.98882 15.9607H13.0115V3.98208H3.98882V15.9607ZM5.87505 13.64V6.32566C5.87505 5.97895 6.13918 5.74356 6.45455 5.74356C6.77425 5.74356 7.03406 6.00586 7.03406 6.32566V13.64C7.03406 13.9598 6.77426 14.2221 6.45455 14.2221C6.13486 14.2221 5.87505 13.9598 5.87505 13.64ZM9.96594 13.64V6.32566C9.96594 5.97897 10.2299 5.74356 10.5454 5.74356C10.8651 5.74356 11.1249 6.00586 11.1249 6.32566V13.64C11.1249 13.9598 10.8652 14.2221 10.5454 14.2221C10.2257 14.2221 9.96594 13.9598 9.96594 13.64Z"
        fill="#2C272D"
        stroke="#2C272D"
        strokeWidth="0.25"
      />
    </svg>
  ),
  minus: (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="minicart_minus"
    >
      <title id="minicart_minus">minus icon</title>
      <path d="M3 8.5L14 8.5" stroke="#523178" strokeLinecap="round" />
    </svg>
  ),
  plus: (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="minicart_plus"
    >
      <title id="minicart_plus">plus icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.73438 3.15625C8.73438 2.88011 8.51052 2.65625 8.23438 2.65625C7.95823 2.65625 7.73438 2.88011 7.73438 3.15625V7.96875L2.92187 7.96875C2.64573 7.96875 2.42188 8.19261 2.42188 8.46875C2.42188 8.74489 2.64573 8.96875 2.92188 8.96875L7.73438 8.96875V13.7812C7.73438 14.0574 7.95823 14.2812 8.23438 14.2812C8.51052 14.2812 8.73438 14.0574 8.73438 13.7812V8.96875L13.5469 8.96875C13.823 8.96875 14.0469 8.74489 14.0469 8.46875C14.0469 8.19261 13.823 7.96875 13.5469 7.96875L8.73438 7.96875V3.15625Z"
        fill="#523178"
      />
    </svg>
  ),
  arrow: (
    <svg
      width="10"
      height="17"
      viewBox="0 0 10 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="minicart_arrow"
    >
      <title id="minicart_arrow">arrow icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.78033 0.21967C10.0732 0.512563 10.0732 0.987437 9.78033 1.28033L2.81066 8.25L9.78033 15.2197C10.0732 15.5126 10.0732 15.9874 9.78033 16.2803C9.48744 16.5732 9.01256 16.5732 8.71967 16.2803L0.68934 8.25L8.71967 0.21967C9.01256 -0.0732233 9.48744 -0.0732233 9.78033 0.21967Z"
        fill="#523178"
      />
    </svg>
  ),
  fancyRightArrow: (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.0934311 10.5411C0.0934311 10.0652 0.479202 9.67945 0.955074 9.67945L14.4407 9.67945C11.5404 7.79955 9.62149 4.56143 9.62149 0.87275C9.62149 0.396878 10.0073 0.0111078 10.4831 0.0111078C10.959 0.0111078 11.3448 0.396878 11.3448 0.87275C11.3448 5.72487 15.3386 9.67938 20.2915 9.67938C20.4226 9.67938 20.5468 9.70863 20.658 9.76095C20.6793 9.771 20.7002 9.7819 20.7206 9.79361C20.9792 9.94231 21.1533 10.2214 21.1533 10.5411C21.1533 11.017 20.7675 11.4027 20.2917 11.4027L20.2659 11.4027C15.3249 11.4163 11.3448 15.3656 11.3448 20.2093C11.3448 20.6852 10.959 21.071 10.4831 21.071C10.0073 21.071 9.62149 20.6852 9.62149 20.2093C9.62149 16.5207 11.5404 13.2827 14.4405 11.4027L0.955074 11.4027C0.479202 11.4027 0.0934311 11.017 0.0934311 10.5411Z"
        fill="#2C272D"
      />
    </svg>
  ),
  sunglasses: (
    <svg width="76" height="30" viewBox="0 0 76 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M45.9612 14.3587C45.9612 18.7317 42.4162 22.2767 38.0431 22.2767C33.6701 22.2767 30.1251 18.7317 30.1251 14.3587C30.1251 9.98568 33.6701 6.44065 38.0431 6.44065C42.4162 6.44065 45.9612 9.98568 45.9612 14.3587Z"
        stroke="#E4E4E4"
        strokeWidth="2.7541"
      />
      <rect x="17.0449" y="15.3916" width="42.6886" height="11.0164" fill="white" />
      <path
        d="M9.45157 24.9095L9.45165 24.9094L9.44502 24.9037C6.89569 22.7279 4.68682 20.1824 2.892 17.3518L2.89205 17.3518L2.88859 17.3466C1.59238 15.3825 0.889741 13.0864 0.864771 10.7333C0.86511 7.87463 1.67102 5.36537 3.75178 3.39512L3.75182 3.39509C6.19084 1.08493 9.65895 0.640463 12.7662 2.17796C14.164 2.87781 15.3899 3.87773 16.3565 5.1063C16.4234 5.19195 16.4937 5.27508 16.5593 5.35269C16.579 5.37593 16.5982 5.39866 16.6168 5.42083L16.6521 5.46297L16.6988 5.49201C16.7547 5.52671 16.8158 5.55216 16.8797 5.56738L17.0799 5.615L17.2166 5.46131C17.34 5.32265 17.4583 5.18579 17.5748 5.05102C17.8225 4.76446 18.0621 4.48736 18.3248 4.22249L18.3249 4.22258L18.3312 4.21587C19.6703 2.79135 21.4221 1.82229 23.3404 1.44492L23.3404 1.44493L23.344 1.44419C24.8929 1.12236 26.5034 1.28694 27.9552 1.91541C29.407 2.54388 30.6292 3.60554 31.4545 4.95517L31.4544 4.95521L31.4587 4.9619C32.7934 7.03517 33.2079 9.32539 32.9929 11.7833C32.7797 14.211 31.7741 16.3363 30.3815 18.3313C27.9203 21.8422 24.9897 24.868 21.373 27.1763C20.1389 27.9634 18.868 28.5872 17.4357 28.7686C16.3637 28.9013 15.3632 28.5939 14.3341 28.1393C12.5565 27.3089 10.9112 26.2205 9.45157 24.9095Z"
        fill="#E4E4E4"
        stroke="#E4E4E4"
        strokeWidth="0.688526"
      />
      <path
        d="M51.4496 24.9095L51.4497 24.9094L51.4431 24.9037C48.8937 22.7279 46.6849 20.1824 44.89 17.3518L44.8901 17.3518L44.8866 17.3466C43.5904 15.3825 42.8878 13.0864 42.8628 10.7333C42.8632 7.87463 43.6691 5.36537 45.7498 3.39512L45.7499 3.39509C48.1889 1.08493 51.657 0.640463 54.7642 2.17796C56.162 2.87781 57.388 3.87773 58.3545 5.1063C58.4215 5.19195 58.4918 5.27508 58.5574 5.35269C58.577 5.37593 58.5962 5.39866 58.6148 5.42083L58.6502 5.46297L58.6969 5.49201C58.7527 5.52671 58.8138 5.55216 58.8778 5.56738L59.0779 5.615L59.2147 5.46131C59.338 5.32265 59.4564 5.18579 59.5729 5.05102C59.8206 4.76446 60.0601 4.48736 60.3228 4.22249L60.3229 4.22258L60.3292 4.21587C61.6683 2.79135 63.4202 1.82229 65.3385 1.44492L65.3385 1.44493L65.3421 1.44419C66.891 1.12236 68.5015 1.28694 69.9533 1.91541C71.4051 2.54388 72.6272 3.60554 73.4526 4.95517L73.4525 4.95521L73.4568 4.9619C74.7914 7.03517 75.206 9.32539 74.991 11.7833C74.7778 14.211 73.7721 16.3363 72.3796 18.3313C69.9184 21.8422 66.9878 24.868 63.371 27.1763C62.1369 27.9634 60.866 28.5872 59.4337 28.7686C58.3617 28.9013 57.3612 28.5939 56.3321 28.1393C54.5545 27.3089 52.9093 26.2205 51.4496 24.9095Z"
        fill="#E4E4E4"
        stroke="#E4E4E4"
        strokeWidth="0.688526"
      />
    </svg>
  ),
  x: (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.37902 0.442998C9.66793 0.731904 9.66793 1.20031 9.37902 1.48922L5.95659 4.91165L9.37902 8.33409C9.66793 8.62299 9.66793 9.0914 9.37902 9.38031C9.09012 9.66921 8.62171 9.66921 8.3328 9.38031L4.38726 5.43476C4.09835 5.14586 4.09835 4.67745 4.38726 4.38854L8.3328 0.442998C8.62171 0.154092 9.09012 0.154092 9.37902 0.442998Z"
        fill="#2C272D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.445195 9.38024C0.156289 9.09134 0.156289 8.62293 0.445195 8.33402L3.86763 4.91159L0.445195 1.48915C0.156289 1.20025 0.156289 0.73184 0.445195 0.442934C0.734101 0.154028 1.20251 0.154028 1.49142 0.442934L5.43696 4.38848C5.72587 4.67738 5.72587 5.14579 5.43696 5.4347L1.49142 9.38024C1.20251 9.66915 0.734101 9.66915 0.445195 9.38024Z"
        fill="#2C272D"
      />
    </svg>
  ),
  ruler: (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_88_1387)">
        <g clipPath="url(#clip1_88_1387)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.16475 11.5639C1.03482 11.434 1.03482 11.2228 1.16475 11.0928L10.5928 1.66474C10.7228 1.53481 10.934 1.53481 11.0639 1.66474L14.8355 5.43626C14.9654 5.56619 14.9654 5.77744 14.8355 5.90736L5.40737 15.3355C5.27744 15.4654 5.0662 15.4654 4.93627 15.3355L1.16475 11.5639ZM1.8723 11.3284L5.17185 14.6279L14.1283 5.67152L10.8287 2.37197L1.8723 11.3284Z"
            fill="#2C272D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.76408 7.7929L10.1214 10.1502L9.65027 10.6213L7.29297 8.26401L7.76408 7.7929Z"
            fill="#2C272D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.8285 4.72838L13.1858 7.08569L12.7142 7.55724L10.3569 5.19994L10.8285 4.72838Z"
            fill="#2C272D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.22852 11.3284L6.58582 13.6857L7.05738 13.2142L4.70007 10.8569L4.22852 11.3284Z"
            fill="#2C272D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.3578 7.08579L11.772 8.5L11.3004 8.97156L9.88623 7.55734L10.3578 7.08579Z"
            fill="#2C272D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.58594 10.8574L8.00015 12.2716L8.47171 11.8001L7.05749 10.3859L6.58594 10.8574Z"
            fill="#2C272D"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_88_1387">
          <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
        </clipPath>
        <clipPath id="clip1_88_1387">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(-3.31348 8.5) rotate(-45)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  question: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="5" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1C11.8566 1 15 4.14329 15 8C15 11.8567 11.8567 15 8 15C4.14329 15 1 11.8567 1 8C1 4.14329 4.14329 1 8 1ZM8.7002 10.8V12.1997H7.29983V10.8H8.7002ZM10.8001 6.59824C10.8001 5.0555 9.5441 3.80017 7.99994 3.80017C6.45579 3.80017 5.19978 5.05553 5.19978 6.59824H6.60014C6.60014 5.83045 7.23209 5.19916 7.99986 5.19916C8.76763 5.19916 9.39958 5.83045 9.39958 6.59824C9.39958 7.21771 8.99337 7.53073 8.53796 7.8805C7.95982 8.32476 7.3036 8.8294 7.3036 10.0998H8.70396C8.70396 9.33336 9.20072 8.89829 9.70995 8.4514C10.2474 7.98023 10.7999 7.49659 10.7999 6.59829L10.8001 6.59824Z"
        fill="#2C272D"
      />
    </svg>
  ),
};

const Icon = ({ id, ...other }) => React.cloneElement(icons[id], other);

export default Icon;
